/**
 * Runtime tenancy flag for the webapp (client + server components).
 *
 * Standalone (default): single tenant; no X-Tenant-Key header, single-tenant GTM.
 * Multi-tenant (opt-in): the host → tenant_key map (config/tenantByHost.json)
 * drives the X-Tenant-Key request header and host-based GTM/GA injection.
 *
 * Opt in with NEXT_PUBLIC_MULTI_TENANT=true. NEXT_PUBLIC_ is inlined at BUILD
 * time, so the value must be present when `next build` runs (build args / CI env),
 * not only injected as runtime pod env.
 *
 * Accepts "true" | "1" | "yes" | "on" (case/space-insensitive) so a value coming
 * from a YAML/ConfigMap pipeline (e.g. `NEXT_PUBLIC_MULTI_TENANT: "true"`, or a
 * boolean stringified to "True") behaves the same as the server's isMultiTenant().
 */
const FLAG = String(process.env.NEXT_PUBLIC_MULTI_TENANT ?? "")
  .trim()
  .toLowerCase();

export const IS_MULTI_TENANT =
  FLAG === "true" || FLAG === "1" || FLAG === "yes" || FLAG === "on";
